export function FullPageErrorFallback({ error }: any) {
  return (
    <div
      role='alert'
      className='w-full flex flex-col items-center justify-center my-4'
    >
      <p>متاسفانه مشکلی پیش آمده است. لطفا دقایقی دیگر تلاش نمایید.</p>
      <pre>{error.message}</pre>
    </div>
  )
}
